var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form',_vm._g({attrs:{"data-ot-cp-id":_vm.collectionPointIdWithSuffix,"data-testid":"onetrust-form"}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }